import { Theme, ThemeBackgroundGradient, ThemeBackgroundType, ThemeButtonSize, ThemeFontVariant, ThemeIntent } from "./types"

export const THEMES: Record<string, Theme> = {
  THEME_1: "theme-1",
  THEME_2: "theme-2",
  THEME_3: "theme-3",
  THEME_4: "theme-4",
  THEME_5: "theme-5",
  THEME_6: "theme-6",
}

export const LIGHTER_THEMES: Record<string, Theme> = {
  THEME_5: "theme-5",
}

export const THEME_INTENTS: Record<string, ThemeIntent> = {
  PRIMARY: "primary",
  DEFAULT: "default",
}

export const THEME_BUTTON_SIZES: Record<string, ThemeButtonSize> = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
};

export const THEME_BACKGROUND_GRADIENTS: Record<string, ThemeBackgroundGradient> = {
  DARK: "dark",
  LIGHT: "light",
};

export const THEME_FONT_VARIANTS: Record<string, ThemeFontVariant> = {
  FONT_VARIANT_1: "font-variant-1",
  FONT_VARIANT_2: "font-variant-2",
  FONT_VARIANT_3: "font-variant-3",
};

export const THEME_BACKGROUND_TYPES: Record<string, ThemeBackgroundType> = {
  DARK: "dark",
  LIGHT: "light",
};
